module.exports = __webpack_public_path__ + "img/photo1.c661dcf5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/photo1.jpg
// module id = AyDt
// module chunks = 1